import type { PropsWithChildren } from 'react';
import { Link, useLocation } from 'react-router-dom';

import type { Court, Division } from '@/types/api';
import { cn } from '@/utils/cn';

export const CommentatorsLayout = ({
  courts,
  divisions,
  children,
}: PropsWithChildren<{ courts: Court[]; divisions: Division[] }>) => {
  const { pathname } = useLocation();

  return (
    <div className="flex size-full">
      <div className="flex w-64 flex-col gap-2 p-4">
        <h1 className="font-semibold">Divisions</h1>

        <div className="flex flex-col gap-2">
          {divisions &&
            divisions.map((division) => (
              <Link
                key={division.id}
                to={`/commentators/divisions/${division.id}`}
                className={cn(
                  'w-full rounded-lg border px-3 py-2 shadow hover:bg-gray-100',
                  pathname.startsWith(
                    `/commentators/divisions/${division.id}`,
                  ) && 'bg-gray-100',
                )}
              >
                {division.name}
              </Link>
            ))}
        </div>

        <h1 className="mt-8 font-semibold">Courts</h1>

        <div className="flex flex-col gap-2">
          {courts &&
            courts.map((court) => (
              <Link
                key={court.id}
                to={`/commentators/courts/${court.id}/lineups`}
                className={cn(
                  'w-full rounded-lg border px-3 py-2 shadow hover:bg-gray-100',
                  pathname.startsWith(`/commentators/courts/${court.id}`) &&
                    'bg-gray-100',
                )}
              >
                {court.name}
              </Link>
            ))}
        </div>
      </div>
      <div className="flex flex-col p-4">{children}</div>
    </div>
  );
};
